import { render, staticRenderFns } from "./NewCompanyPage.vue?vue&type=template&id=9cf929a4&scoped=true&"
import script from "./NewCompanyPage.vue?vue&type=script&lang=js&"
export * from "./NewCompanyPage.vue?vue&type=script&lang=js&"
import style0 from "./NewCompanyPage.vue?vue&type=style&index=0&id=9cf929a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf929a4",
  null
  
)

export default component.exports